import React from 'react';
import { Divider, Tooltip, Button } from 'antd';
import { httpClient } from "util/Api";
import { config } from "util/config";
import { GroupOutlined, PlusSquareOutlined, ProfileOutlined, EditOutlined, DeleteOutlined, OrderedListOutlined, FolderOutlined, FolderOpenOutlined, CaretRightOutlined, CaretDownOutlined } from '@ant-design/icons';
import JobChecklistGroup from './JobChecklistGroup';
import * as jobChecklist from 'components/UIBuilder/SectionFunction/JobChecklist';
import CustomBadge from 'components/CustomBadge';


export default class JobChecklistFolder extends React.Component {
  constructor(props) {
    super();
    this.state = {
      data: [],
      counter: 0
    }
  }

  //计算Folder有多少Checklist
  getJobChecklistCounter() {
    let counter = 0;
    this.props.data.JobChecklistGroupList.map((jobChecklistGroup, i) => {
      counter += jobChecklistGroup.JobChecklistList.length;
    })
    return counter;
  }

  render() {
    return (
      <>
        <div className='folder-div'>
          {
            this.props.data.key !== 0 ?
              <Button
                icon={this.props.data.Collapsed === true ?
                  <CaretRightOutlined style={{ marginRight: '4px' }} /> :
                  <CaretDownOutlined style={{ marginRight: '4px' }} />}
                type="link"
                style={{ width: 'auto', color: '#495057', padding: '0px', height: '18px', lineHeight: '18px' }}
                onClick={() => {
                  jobChecklist.collapseFolder({ component: this.props.component, key: this.props.data.key, pageComponent: this.props.pageComponent });
                }}
              ><b>{this.props.data.Name} ({this.getJobChecklistCounter()})</b></Button> : <b>{this.props.data.Name} ({this.getJobChecklistCounter()})</b>
          }

          <Divider />
          {
            this.props.data.JobChecklistGroupList.map((jobChecklistGroupData, i) =>
              <div key={i} style={{ display: this.props.data.Collapsed !== true ? 'block' : 'none', marginBottom: '14px' }}>
                <JobChecklistGroup
                  {...this.props}
                  jobChecklistFolderId={this.props.data.JobChecklistFolderId}
                  data={jobChecklistGroupData}
                />
              </div>
            )
          }
        </div>
      </>
    )
  }
}
